var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.static_invoice)?_c('StaticInvoiceViewer',_vm._b({key:_vm.invoice_id.toString()},'StaticInvoiceViewer',{invoice: _vm.static_invoice, configuration:_vm.configuration, rectified_inv:_vm.rectificative_invoice},false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }